import React from 'react';
import './Modal.css';

const ExtraCardModal = ({ card, onAction, onClose }) => {
  if (!card) return null;

  const type = card.type || '';
  const isLink = type.includes('Link');
  const isXYZ = type.includes('XYZ');

  let actions = ['Reveal', 'Banish FD', 'Banish', 'To GY'];

  if (isLink) {
    actions.push('SS ATK');
  } else {
    actions.push('SS DEF', 'SS ATK');
  }

  if (isXYZ) {
    actions.push('XYZ Summon');
  }


  return (
    <div className="modal-backdrop">
      <div className="modal-content hand-menu-modal">
        <div className="modal-left">
          <img
            src={card.card_images[0].image_url}
            alt={card.name}
            className="modal-card-image"
          />
          <div className="modal-card-info">
            <h3>{card.name}</h3>
            <p><strong>Card:</strong> {card.type}</p>
            {card.atk !== undefined && (
              <p><strong>ATK/DEF:</strong> {card.atk} / {card.def ?? '—'}</p>
            )}
            {card.level && <p><strong>Level:</strong> {card.level}</p>}
            {card.linkval && <p><strong>Link Rating:</strong> {card.linkval}</p>}
            {card.race && <p><strong>Type:</strong> {card.race}</p>}
            {card.attribute && <p><strong>Attribute:</strong> {card.attribute}</p>}
            <p dangerouslySetInnerHTML={{ __html: card.desc.replace(/\n/g, '<br/>') }} />
          </div>
        </div>

        <div className="modal-right">
          <h3>Choose Action</h3>
          <ul className="action-list">
            {actions.map((action, index) => (
              <li key={index} onClick={() => onAction(action)}>{action}</li>
            ))}
          </ul>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ExtraCardModal;
